<template>
  <div class="buy_packet">
    <h2>Купить пакет занятий</h2>
    <div class="buy_packet__subtitle">Выберите количество пакетов</div>
    <div class="buy_packet__qnts">
      <label v-for="qnt in qnts">
        <input type="radio" :value="qnt" v-model="current_qnt">
        <span><i>{{ qnt }}</i></span>
      </label>
    </div>
    <div class="buy_packet__order">
      <p>Количество занятий: <span>{{ lesson_count }}</span></p>
      <p>К оплате: <span>{{ total }}</span> руб</p>
      <div class="buy_packet__button">
        <button class="uk-button uk-button-primary" @click="makePayment">Перейти к оплате</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "buy_packet",
  data() {
    return {
      qnts: [
        1, 3, 5, 7, 8, 9, 12, 18
      ],
      current_qnt: 3
    }
  },
  inject: ['http'],
  computed: {
    ...mapState(['user']),
    ...mapState('billing', ['lessons', 'subscribe']),
    type() {
      return this.subscribe.subscribe_type
    },
    total() {
      return this.current_qnt * this.type.price;
    },
    lesson_count() {
      return this.subscribe.days.length * (this.current_qnt * 4);
    }
  },
  props: {
    items: ''
  },
  methods: {
    async makePayment() {
      let payment_data = {
        'user_id': this.user.id,
        'subscribe_id': this.subscribe.id,
        'qnt': this.current_qnt,
        'lesson_count': this.lesson_count,
        'total': this.total,
        'payment_system': 'sber',
        'return_url': '/billing',
        'desc': 'Биллинг МА: ' + this.user.email
      }
      let result = await this.http.post('onCreateSubscribePayment', payment_data).then(res => res.data);
      console.log(result);
      if (result.payment_link) document.location.href = result.payment_link;
      if (result.message) swal(result.message);
    }
  },
  mounted() {

  }
}
</script>